"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Record = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var investment_1 = require("../../model/investment");
var service_1 = require("../../../library/base/service");
var Record = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Record, _super);
    function Record() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '投资记录初始化接口';
        _this.code = '101013';
        _this.desc = '投资记录初始化接口';
        _this.requestParams = new investment_1.RecordRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Record;
}(service_1.BaseService));
exports.Record = Record;
//# sourceMappingURL=record.js.map